import { render, staticRenderFns } from "./ekhizmetler.vue?vue&type=template&id=efd1a1f4"
import script from "./ekhizmetler.vue?vue&type=script&lang=js"
export * from "./ekhizmetler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports